<template lang="pug">
div(:class="{'withapps' : showTopbanner }")
  .mob-evebanner(v-if="showTopbanner")
    .cclose.vv-close-evebanner(@click="hideTopbanner")
      img(src='assets/img/cancel-icon.png')
    a(v-if="showTopbanner && !isIOS" href="https://dapk.epwin21.com/epicwin.apk" download="epicwin.apk" target="_blank")
      img(src='assets/img/app-download.jpg')
    a(v-if="isIOS && showTopbanner" href='javascript:void(0)' @click="openTutorial")
      img(src='assets/img/app-download.jpg')
  #leaderboard-modal.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer(@click="$helpers.closeModal('#leaderboard-modal')")
          i.fa-solid.fa-x.fa-2x
        .modal-body
          iframe#testIframe(style="width:100%; min-height: 600px;")
        .modal-footer.s2
          .text-center
            button.btn-submit(type='button' @click="$helpers.closeModal('#leaderboard-modal')") {{ $t('ui.close') }}
  #offcanvasWithBackdrop.offcanvas.offcanvas-end(tabindex='-1' aria-labelledby='offcanvasWithBackdropLabel')
    .offcanvas-header
      h5#offcanvasWithBackdropLabel.offcanvas-title
        router-link(to="/")
          img(src='assets/img/logo.png')
      // <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    .offcanvas-body
      //- .button-area(v-if="!isLoggedIn")
        a.btn-login(href="javascript:void(0)" @click="openModal('#logModal')") {{$t('ui.login')}}
        a.btn-register(href="javascript:void(0)" @click="openModal('#regModal')") {{$t('ui.register')}}
      .reward(v-if="isLoggedIn")
        //- div(data-bs-dismiss="offcanvas")
        //-   router-link(to="/inbox")
        //-     img(src='assets/img/inbox.png')
        //- div
        //-   router-link(to="vip")
        //-     img(src='assets/img/vip.png')
        div
          a(href="javascript:void(0)" @click="gamification()")
            img(src='assets/img/missions.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="referral")
            img(src='assets/img/side-referral.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="ambassador")
            img(src='assets/img/m/menu/ambasaddor.png')
        //- div
          a(href="javascript:void(0)" @click="eventAction()")
            img(src='assets/img/leaderboard.png')
      .reward(v-else)
        //- div(data-bs-dismiss="offcanvas")
          a(href="javascript:void(0)" @click="openModal('#logModal')")
            img(src='assets/img/inbox.png')
        //- div
          router-link(to="/")
            img(src='assets/img/wheel.png')
        div(data-bs-dismiss="offcanvas")
          a(href="javascript:void(0)" @click="openModal('#logModal')")
            img(src='assets/img/mission.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="referral")
            img(src='assets/img/side-referral.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="ambassador")
            img(src='assets/img/m/menu/ambasaddor.png')
        //- div
          a(href="javascript:void(0)" @click="openModal('#logModal')")
            img(src='assets/img/leaderboard.png')
      hr
      .cat
        div(data-bs-dismiss="offcanvas")
          template(v-if="isLoggedIn")
            router-link(to="deposit")
              img(src='assets/img/m/menu/deposit.png')
          template(v-else)
            a(href="javascript:void(0)" @click="openModal('#logModal')")
              img(src='assets/img/m/menu/deposit.png')
        div(data-bs-dismiss="offcanvas")
          template(v-if="isLoggedIn")
            router-link(to="withdrawal")
              img(src='assets/img/m/menu/withdraw.png')
          template(v-else)
            a(href="javascript:void(0)" @click="openModal('#logModal')")
              img(src='assets/img/m/menu/withdraw.png')
        div(data-bs-dismiss="offcanvas")
          template(v-if="isLoggedIn")
            router-link(to="statement")
              img(src='assets/img/m/menu/record.png')
          template(v-else)
            a(href="javascript:void(0)" @click="openModal('#logModal')")
              img(src='assets/img/m/menu/record.png')
        div(data-bs-dismiss="offcanvas")
          a(href="javascript:void(0)" @click="openChat()")
            img(src='assets/img/m/menu/support.png')
        div(v-if="getFbLink!==''")
          a(:href="getFbLink" target="_blank")
            img(src='assets/img/m/menu/facebook.png')
        div(v-if="getTgLink!==''")
          a(:href="getTgLink" target="_blank")
            img(src='assets/img/m/menu/telegram.png')
        div(v-if="getIgLink!==''")
          a(:href="getIgLink" target="_blank")
            img(src='assets/img/m/menu/instagram.png')
        div(v-if="getYtLink!==''")
          a(:href="getYtLink" target="_blank")
            img(src='assets/img/m/menu/youtube.png')
        div
          a(href="javascript:void(0)" @click="toggleLang")
            //- img(:src="'assets/img/m/menu/'+getLanguage+'.png'")
            img(src="assets/img/m/menu/language.png")
          .lang-option.d-flex.mt-2(v-if="showLang")
            img.me-3(src='assets/img/lang-en.png' @click="setLanguage('en')")
            img(src='assets/img/lang-ph.png' @click="setLanguage('ph')")
        div(data-bs-dismiss="offcanvas")
          router-link(to="freeplay")
            img(src='assets/img/m/menu/demoplay.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="review")
            img(src='assets/img/m/menu/review.png')
        div(data-bs-dismiss="offcanvas")
          router-link(to="news")
            img(src='assets/img/m/menu/news.png')
        div(data-bs-dismiss="offcanvas")
          template(v-if="isLoggedIn")
            router-link(to="setting")
              img(src='assets/img/m/menu/setting.png')
          template(v-else)
            a(href="javascript:void(0)" @click="openModal('#logModal')")
              img(src='assets/img/m/menu/setting.png')
        //- div(data-bs-dismiss="offcanvas")
          router-link(to="referral")
            img(src='assets/img/m/menu/referral.png')
        //- div(data-bs-dismiss="offcanvas")
          template(v-if="isLoggedIn")
            a(href="javascript:void(0)")
              img(src='assets/img/m/menu/guide.png')
        //- div(data-bs-dismiss="offcanvas")
          router-link(to="/")
            img(src='assets/img/m/menu/event.png')
      hr
      .button-area.d-block.text-center(v-if="isLoggedIn" data-bs-dismiss="offcanvas")
        a.btn-register(@click="logout")
          i.fa-solid.fa-arrow-right-from-bracket
          | {{$t('ui.logout')}}
  .main-bbg.home
  leftsidebar
  .mob-top(v-if="showTop")
    .ll(v-if="!showProfile")
      router-link(to='/')
        i.fas.fa-chevron-left
    .ll(v-else)
      //- router-link(to='/profile')
      a(href="javascript:void(0)" @click="toProfile")
        i.fas.fa-chevron-left
    .cc {{getDisplayWord()}}
  .wrapper(:class="{'article-view' : currentPath === '/' || currentPath === '/slot' || currentPath === '/epic' || currentPath === '/casino', 'p-0': currentPath === '/ambassador' && showMobile === false}")
    template(v-if="!showMobile")
      .access(v-if="isLoggedIn && showBalance")
        .button-area.w-auto
          .profile.custom-hide
            i.fa-solid.fa-circle-user(v-if="getAvatar===''")
            img(v-else :src="getAvatar")
          .text-left.custom-hide.user-info.pointer(@click="$helpers.redirect('deposit')")
            span.username.float-start {{accountID}}
            br
            span.balance.float-start PHP {{ $numeral($store.getters.balance).format("0,0.00") }}
              i.fa-solid.fa-eye
          .lvl-img.pointer.ms-1(v-if="getVip!==''")
            img.lvl-img.custom-hide.pointer(v-if="getVip!==''" :src="'assets/img/vip/'+getVip+'.png'" @click="$helpers.redirect('vip')")
          .dropdown.lang
            button#lang.btn.dropdown-toggle(type='button' data-bs-toggle='dropdown' aria-expanded='false')
              a(href='javascript:void(0)')
                img(:src="'assets/img/lang-'+getLanguage+'.png'")
            ul.dropdown-menu(aria-labelledby='lang')
              li
                a(href='javascript:void(0)' @click="setLanguage('ph')")
                  img(src='assets/img/lang-ph.png')
              li
                a(href='javascript:void(0)' @click="setLanguage('en')")
                  img(src='assets/img/lang-en.png')
      router-view
      //- footerArticle.text-white
    template(v-else)
      template(v-if="showTop")
        router-view
      template(v-else)
        topbar
        .conbox
          .hometabs
            tabList
            router-view
        footerBanner
        footerInfo
    footerArticle.text-white(v-if="currentPath === '/' || currentPath === '/slot' || currentPath === '/epic' || currentPath === '/casino'" :target="currentPath")
    .mob-nav
      router-link(to="/" :class="{'aaa': currentPath==='/'}")
        img(src="assets/img/menu/m-home.png")
        span.text-capitalize {{$t('ui.home')}}
      router-link(to="promotions" :class="{'aaa': currentPath==='/promotions'}")
        img(src="assets/img/menu/m-promo.png")
        span {{$t('ui.promotion')}}
      router-link.ccen(to="vip" v-if="isLoggedIn")
        img.animate__animated.animate__jello.animate__infinite(src="assets/img/menu/m-reward2.png")
      a.ccen(v-else href="javascript:void(0)" @click="openModal('#logModal')")
        img.animate__animated.animate__jello.animate__infinite(src="assets/img/menu/m-reward2.png")
      router-link(to="inbox" :class="{'aaa': currentPath==='/inbox'}" v-if="isLoggedIn")
        img(src="assets/img/menu/m-peso.png")
        span REWARDS
      a(v-else href="javascript:void(0)" @click="openModal('#logModal')")
        img(src="assets/img/menu/m-peso.png")
        span REWARDS
      //- router-link(v-if="isLoggedIn" to="profile" :class="{'aaa': currentPath==='/profile'}")
      //-   img(src="assets/img/menu/m-menu.png")
      //-   span {{$t('ui.profile')}}
      //- a(v-else href="javascript:void(0)" @click="openModal('#logModal')")
      a(href="javascript:void(0)" data-bs-toggle='offcanvas' data-bs-target='#offcanvasWithBackdrop')
        img(src="assets/img/menu/m-menu.png")
        span MENU
    .float-icon
      //- a(v-if="showPrompt && !isIOS" href='javascript:void(0)' @click="triggerDownload")
      //-   img(src='assets/img/float-download.png')
      //- a(v-if="showPrompt && !isIOS" :href="downloadLink" download="epicwin.apk" target="_blank")
      //- template(v-if="!isIOS && showDownload" )
        a(href="https://dapk.epwin21.com/epicwin.apk" download="epicwin.apk" target="_blank")
          img(src='assets/img/float-download.png')
        .close-tutorial(@click="hideDownload")
          img(src='assets/img/cancel-icon.png')
      //- a(v-if="isIOS && showTutorial" href='javascript:void(0)')
        img(src='assets/img/float-download.png' @click="openTutorial")
        .close-tutorial(@click="hideTutorial")
          img(src='assets/img/cancel-icon.png')
      a(href='https://epicwinjili.com/winning-tips/' target="_blank" )
        img(src="assets/img/winning_tips.png")
      a(href='javascript:void(0)' @click="openChat")
        img(src='assets/img/float-livechat.png')
      a(href='http://m.me/115727134962691' target="_blank" )
        img(src="assets/img/msngr.png")
    .float-eve(:class="{'no': hideIcon}" )
      .evebox.text-center
        a(href='https://epicwinjili.com/winning-tips/' target="_blank" )
          img(src="assets/img/winning_tips.png")
        a(href='javascript:void(0)' @click="openChat")
          img(src="assets/img/float-livechat.png")
        a(href='http://m.me/115727134962691' target="_blank" )
          img(src="assets/img/msngr.png")
      .arrow.vv-evearrow(@click="toggleIcon")
        span
          i.fa-solid.fa-caret-left
  template(v-if="!isLoggedIn")
    register
    login
    forgotPassword
  template(v-else)
    review
    reviewComplete
  popupBanner
  tutorial
</template>
<script>
import config from "@/config";
import _ from "lodash";
import leftsidebar from "@/views/default/_leftBar.vue";
import rightsidebar from "@/views/default/_rightBar.vue";
import topbar from "@/views/default/_topBar.vue";
import tabList from "@/views/default/_tabs.vue";
import register from "@/component/_register.vue";
import login from "@/component/_login.vue";
import forgotPassword from "@/component/_forgotPassword.vue";
import popupBanner from "@/component/_popupBanner.vue";
import footerBanner from "@/views/default/_footerBanner.vue";
import footerInfo from "@/views/default/_footer.vue";
import footerArticle from "@/views/default/_footerArticle.vue";
import tutorial from "@/component/_tutorial.vue";
import review from "@/component/review/_review.vue";
import reviewComplete from "@/component/review/_reviewComplete.vue";

export default {
  metaInfo(){
    var site = window.location.protocol + "//" + window.location.hostname + "/";
    if(this.ph88.includes(site)){
      return {
        script: [
          {
            vmid: 'ga-script',
            src: 'https://www.googletagmanager.com/gtag/js?id=G-BLTBKNQWQ9',
            async: true,
          },
          {
            vmid: 'ga-config',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-BLTBKNQWQ9');
            `,
            type: 'text/javascript',
            charset: 'utf-8'
          }
        ],
        __dangerouslyDisableSanitizers: ['script']
      };
    }else if(this.default.includes(site)){
      return {
        script: [
          {
            vmid: 'gtm-body',
            innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5DWDGV3X');",
            type: 'text/javascript'
          }
        ],
        noscript: [
          {
            vmid: 'gtm-noscript',
            innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5DWDGV3X" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
            pbody: true
          }
        ]
      }
    }else{
      return {
        script: [
          {
            vmid: 'ga-script',
            src: 'https://www.googletagmanager.com/gtag/js?id=G-2F07593391',
            async: true,
          },
          {
            vmid: 'ga-config',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-2F07593391');
            `,
            type: 'text/javascript',
            charset: 'utf-8'
          }
        ],
        __dangerouslyDisableSanitizers: ['script']
      };
    }
  },
  components: {
    leftsidebar,
    rightsidebar,
    tabList,
    topbar,
    register,
    login,
    forgotPassword,
    popupBanner,
    footerBanner,
    footerInfo,
    footerArticle,
    tutorial,
    review,
    reviewComplete
  },
  data() {
    return {
      showMobile: false,
      showTop: false,
      showBalance: false,
      showProfile:false,
      currentPath: "",
      hideIcon: false,
      levels:[708,709,
        707,
        710,
        711,
        712,
        800,
        801,
        802,
        803,
      ],
      default:[
        "https://epicwin.ph/",
        "http://epicwin.ph/",
        "https://www.epicwin.ph/",
        "http://www.epicwin.ph/"
      ],
      ph88:[
        "https://epicwinph88.com/",
        "http://epicwinph88.com/",
        "https://www.epicwinph88.com/",
        "http://www.epicwinph88.com/"
      ],
      globeArray: [
        "http://www.epic888.asia/",
        "http://www.epic888.cc/",
        "http://www.epic888.co/",
        "http://www.epic888.net/",
        "https://www.epic888.asia/",
        "https://www.epic888.cc/",
        "https://www.epic888.co/",
        "https://www.epic888.net/"
      ],
      smartArray: [
        "http://www.epic8888.asia/",
        "http://www.epic8888.cc/",
        "http://www.epic8888.co/",
        "http://www.epic8888.com/",
        "https://www.epic8888.asia/",
        "https://www.epic8888.cc/",
        "https://www.epic8888.co/",
        "https://www.epic8888.com/"
      ],
      jimMy: [
        "http://epicwinfree8.com/",
        "http://www.epicwinfree8.com/",
        "https://epicwinfree8.com/",
        "https://www.epicwinfree8.com/"
      ],
      app88: [
        "http://epwin10.com/",
        "https://epwin10.com/",
        "http://www.epwin10.com/",
        "https://www.epwin10.com/"
      ],
      app2: [
        "http://epwin8.com/",
        "https://epwin8.com/",
        "http://www.epwin8.com/",
        "https://www.epwin8.com/"
      ],
      appFlyer: [
        "http://epwin10.com/",
        "https://epwin10.com/",
        "http://www.epwin10.com/",
        "https://www.epwin10.com/",
        "http://epwin8.com/",
        "https://epwin8.com/",
        "http://www.epwin8.com/",
        "https://www.epwin8.com/",
        "http://epwin11.com/",
        "https://epwin11.com/",
        "http://www.epwin11.com/",
        "https://www.epwin11.com/",
        "http://epwin12.com/",
        "https://epwin12.com/",
        "http://www.epwin12.com/",
        "https://www.epwin12.com/",
        "http://epwin13.com/",
        "https://epwin13.com/",
        "http://www.epwin13.com/",
        "https://www.epwin13.com/",
        "http://epwin14.com/",
        "https://epwin14.com/",
        "http://www.epwin14.com/",
        "https://www.epwin14.com/",
        "http://epwin15.com/",
        "https://epwin15.com/",
        "http://www.epwin15.com/",
        "https://www.epwin15.com/",
        "http://epicwin.ph/",
        "https://epicwin.ph/",
        "http://www.epicwin.ph/",
        "https://www.epicwin.ph/",
        "http://epicwinph88.com/",
        "https://epicwinph88.com/",
        "http://www.epicwinph88.com/",
        "https://www.epicwinph88.com/",
        "http://epicwin8.xyz/",
        "https://epicwin8.xyz/",
        "http://www.epicwin8.xyz/",
        "https://www.epicwin8.xyz/"
      ],
      app3: [
        "http://epwin11.com/",
        "https://epwin11.com/",
        "http://www.epwin11.com/",
        "https://www.epwin11.com/",
      ],
      app4: [
        "http://epwin12.com/",
        "https://epwin12.com/",
        "http://www.epwin12.com/",
        "https://www.epwin12.com/"
      ],
      app5: [
        "http://epwin13.com/",
        "https://epwin13.com/",
        "http://www.epwin13.com/",
        "https://www.epwin13.com/"
      ],
      app6: [
        "http://epwin14.com/",
        "https://epwin14.com/",
        "http://www.epwin14.com/",
        "https://www.epwin14.com/"
      ],
      app7: [
        "http://epwin15.com/",
        "https://epwin15.com/",
        "http://www.epwin15.com/",
        "https://www.epwin15.com/"
      ],
      globe1: [
        "http://epwin16.com/",
        "https://epwin16.com/",
        "http://www.epwin16.com/",
        "https://www.epwin16.com/"
      ],
      globe2: [
        "http://epwin17.com/",
        "https://epwin17.com/",
        "http://www.epwin17.com/",
        "https://www.epwin17.com/"
      ],
      globe3: [
        "http://epwin18.com/",
        "https://epwin18.com/",
        "http://www.epwin18.com/",
        "https://www.epwin18.com/"
      ],
      globe4: [
        "http://epwin19.com/",
        "https://epwin19.com/",
        "http://www.epwin19.com/",
        "https://www.epwin19.com/"
        // "http://эпвин.рус/",
        // "https://эпвин.рус/",
        // "http://www.эпвин.рус/",
        // "https://www.эпвин.рус/",
        // "https://xn--b1ampf3e.xn--p1acf/",
        // "http://xn--b1ampf3e.xn--p1acf/",
      ],
      // affiBlack:[
      //   "http://epicwin66.com/",
      //   "https://epicwin66.com/",
      //   "http://www.epicwin66.com/",
      //   "https://www.epicwin66.com/"
      // ],
      adsss:[
        "http://epicwinph.xyz/",
        "https://epicwinph.xyz/",
        "http://www.epicwinph.xyz/",
        "https://www.epicwinph.xyz/"
      ],
      pin:[
        "http://epicphjili.xyz/",
        "https://epicphjili.xyz/",
        "http://www.epicphjili.xyz/",
        "https://www.epicphjili.xyz/"
      ],
      bio:[
        "http://epicwin.fun/",
        "https://epicwin.fun/",
        "http://www.epicwin.fun/",
        "https://www.epicwin.fun/"
      ],
      tips:[
        "http://epicwin8.club/",
        "https://epicwin8.club/",
        "http://www.epicwin8.club/",
        "https://www.epicwin8.club/"
      ],
      bb3:[
        "http://epicwinph.site/",
        "https://epicwinph.site/",
        "http://www.epicwinph.site/",
        "https://www.epicwinph.site/"
      ],
      blogg:[
        "http://epicwinph.live/",
        "https://epicwinph.live/",
        "http://www.epicwinph.live/",
        "https://www.epicwinph.live/"
      ],
      slots:[
        "http://epicphjili.site/",
        "https://epicphjili.site/",
        "http://www.epicphjili.site/",
        "https://www.epicphjili.site/"
      ],
      facebooks:[
        "http://epicwin8.xyz/",
        "https://epicwin8.xyz/",
        "http://www.epicwin8.xyz/",
        "https://www.epicwin8.xyz/"
      ],
      hdmovie:[
        "http://epicwin8.info/",
        "https://epicwin8.info/",
        "http://www.epicwin8.info/",
        "https://www.epicwin8.info/"
      ],
      john1:[
        "http://epicwin8.site/",
        "https://epicwin8.site/",
        "http://www.epicwin8.site/",
        "https://www.epicwin8.site/"
      ],
      annah:[
        "http://epicwin8.fun/",
        "https://epicwin8.fun/",
        "http://www.epicwin8.fun/",
        "https://www.epicwin8.fun/"
      ],
      marjz:[
        "http://epicwinph.asia/",
        "https://epicwinph.asia/",
        "http://www.epicwinph.asia/",
        "https://www.epicwinph.asia/"
      ],
      shuriken:[
        "http://epicwinph.online/",
        "https://epicwinph.online/",
        "http://www.epicwinph.online/",
        "https://www.epicwinph.online/"
      ],
      tengsss:[
        "http://epicwin66.com/",
        "https://epicwin66.com/",
        "http://www.epicwin66.com/",
        "https://www.epicwin66.com/"
      ],
      moneymeme:[
        "http://epicwinph.website/",
        "https://epicwinph.website/",
        "http://www.epicwinph.website/",
        "https://www.epicwinph.website/"
      ],
      globee:[
        "http://epwin2.com/",
        "https://epwin2.com/",
        "http://www.epwin2.com/",
        "https://www.epwin2.com/"
      ],
      ee6688:[
        "http://epicwinvip.site/",
        "https://epicwinvip.site/",
        "http://www.epicwinvip.site/",
        "https://www.epicwinvip.site/"
      ],
      regina:[
        "http://epicwinjili.online/",
        "https://epicwinjili.online/",
        "http://www.epicwinjili.online/",
        "https://www.epicwinjili.online/"
      ],
      youtube:[
        "http://epicwinjili.site/",
        "https://epicwinjili.site/",
        "http://www.epicwinjili.site/",
        "https://www.epicwinjili.site/"
      ],
      instagram33:[
        "http://epicphwin.com/",
        "https://epicphwin.com/",
        "http://www.epicphwin.com/",
        "https://www.epicphwin.com/"
      ],
      // showPrompt: false,
      isIOS: false,
      showTutorial: false,
      showDownload: false,
      showLang: false,
      showTopbanner: true,
      fbp: null,
      pixelId: "",
      siteName:"",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getLanguage() {
      return this.$store.getters.language || "en";
    },
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getAvatar() {
      return this.$store.getters.getAvatar;
    },
    getCurrentLevel() {
      return this.$store.getters.getCurrentLevel;
    },
    getFbLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "facebook"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getTgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "telegram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getIgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "instagram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getYtLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "youtube"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getVip(){
      return this.$store.state.user.vip
    }
    // downloadLink(){
    //   return window.location.protocol + "//" + window.location.hostname + "/assets/download/epicwin.apk";
    // },
  },
  watch: {
    $route(to, from) {
      this.currentPath = to.path;
      if (
        to.path === "/referral" ||
        to.path === "/deposit" ||
        to.path === "/profile" ||
        to.path === "/setting" ||
        to.path === "/withdrawal" ||
        to.path === "/statement" ||
        to.path === "/inbox" ||
        to.path === "/contactUs" ||
        to.path === "/promotions" || 
        to.path === "/livestream" ||
	      to.path === "/vip" ||
        to.path === "/ambassador"
      ) {
        this.showTop = true;
        this.showBalance = true;
      } else {
        this.showTop = false;
        this.showBalance = false;
      }
    },
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        window._smartico_user_id = null;
        window._smartico_language = null;
        vm.$store.dispatch("user/setCurrentLevel", "");
      }
    }
  },
  created() {
    this.getSocialList();
  },
  beforeMount() {
    this.getMobile();
    this.checkSize();
    // window.addEventListener("beforeinstallprompt", e => {
    //   e.preventDefault();
    //   this.triggerEvent = e;
    //   this.showPrompt = true;
    // });
  },
  updated(){
    if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.checkProfile == true){
				this.showProfile = true
			}
    }
  },
  mounted() {
    var vm = this;
    this.checkDomain();
    $(window).resize(function() {
      vm.checkSize();
    });
    this.currentPath = this.$router.currentRoute.path;
    if (
      this.$router.currentRoute.path === "/referral" ||
      this.$router.currentRoute.path === "/deposit" ||
      this.$router.currentRoute.path === "/profile" ||
      this.$router.currentRoute.path === "/setting" ||
      this.$router.currentRoute.path === "/withdrawal" ||
      this.$router.currentRoute.path === "/statement" ||
      this.$router.currentRoute.path === "/inbox" ||
      this.$router.currentRoute.path === "/contactUs" ||
      this.$router.currentRoute.path === "/promotions" || 
      this.$router.currentRoute.path === "/livestream" ||
      this.$router.currentRoute.path === "/vip" ||
      this.$router.currentRoute.path === "/ambassador"
    ) {
      this.showTop = true;
      this.showBalance = true;
    } else {
      this.showTop = false;
      this.showBalance = false;
    }
    $("#leaderboard-modal").on("shown.bs.modal", function() {
      window._smartico.showWidget("ui-widget", {
        iframe: "testIframe",
        zoom: 1,
        height: "auto",
        wuuid: "100005/79d12290-d465-11ee-9aa0-0228c1221b89",
        id: 2
      });
    });
    $(".chat-close").click(function() {
      $(".chat-gif")
        .removeClass("d-block")
        .addClass("d-none");
      $(".chat-close")
        .removeClass("d-block")
        .addClass("d-none");
    });
    if (!_.isEmpty(this.$route.query)) {
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (this.appFlyer.includes(site)) {
        if (this.$route.query.fbp) {
          this.fbp = this.$route.query.fbp;
          if (localStorage.getItem("fbp") === null) {
            localStorage.setItem("fbp", this.fbp);
          }
          if (this.$route.query.pixelId) {
            this.pixelId = this.$route.query.pixelId;
            if (localStorage.getItem("pixelId") === null) {
              localStorage.setItem("pixelId", this.pixelId);
            }
          }
          this.appflyerSubmit();
        }
      }
      if (this.isLoggedIn) {
        if (this.$route.query.tut) {
          this.gamification();
        }
        this.$router.replace(this.currentPath);
      }
      this.$router.replace("/");
    }
    if (this.isLoggedIn) {
      window._smartico_user_id = this.$store.getters.accountID;
      window._smartico_language = this.getLanguage;
      
    } else {
      // window._smartico_user_id = null;
      // window._smartico_language = null;
    }
    window._smartico.on("props_change", function(props) {
      _smartico.api.getMissions().then( r => 
        // console.log(r.filter( m => m.is_completed).length)
        vm.$store.dispatch("user/setMissions", r.filter( m => m.is_completed).length)
      );

      _smartico.api.getBadges().then( r => 
        // console.log(r.length)
        vm.$store.dispatch("user/setBadges", r.filter( m => m.is_completed).length)
      );



      if(_.isEmpty(props) === false){
        vm.$store.dispatch("user/setSmarticoData", props)
      }
      if (props.avatar_id !== undefined) {
        // console.log('Avatar URL', props.avatar_id);
        vm.$store.dispatch("user/setAvatar", props.avatar_id);
      }
      if (props.ach_level_current_id !== undefined){
        _smartico.api.getLevels().then( ls => {
          // console.log(ls.find( l => l.id === props.ach_level_current_id))
          vm.$store.dispatch("user/setCurrentlvlDetails", ls.find( l => l.id === props.ach_level_current_id));
          var level = vm.levels.indexOf(props.ach_level_current_id)
          if(level === 11){
            vm.$store.dispatch("user/setNextlvlDetails", ls.find( l => l.id === props.ach_level_current_id))
          }else{
            vm.$store.dispatch("user/setNextlvlDetails", ls.find( l => l.id === vm.levels[level+1]))
          }
          
        })
        
      }
      if (props.ach_points_balance !== undefined) {
        // console.log('Points balance', props.ach_points_balance);
      }
      if (props.ach_points_ever !== undefined) {
        // console.log('Points ever-balance', props.ach_points_ever);
      }
      if (props.ach_level_current !== undefined) {
        // console.log('Level name', props.ach_level_current);
        vm.$store.dispatch("user/setCurrentLevel", props.ach_level_current);
      }
      if (props.core_inbox_unread_count !== undefined) {
        // console.log('Unread messages', props.core_inbox_unread_count);
      }
      if (props.ach_gamification_in_control_group !== undefined) {
        // Flag indicating of gamification is disabled for user (true if disabled)
        // console.log('Gamification disabled', props.ach_gamification_in_control_group);
      }
      
    });
    
  },
  methods: {
    toProfile(){
      this.showProfile = false
      this.$router.push("/profile").catch(error =>{})
    },
    appflyerSubmit() {
      var vm = this;
      this.siteName = window.location.protocol + "//" +window.location.hostname
      var url = config.appflyerSubmit();
      this.$http
        .post(url, {
          "fbp": this.fbp,
          "pixelId": this.pixelId,
          "domain": this.siteName,
        })
        .then(
          successResponse => {
            if (successResponse) {
              if (typeof successResponse.data.status == "string") {
                this.feedback.success = successResponse.status == "1";
              } else {
                this.feedback.success = successResponse.status == 1;
              }
              this.feedback.status = successResponse.status;
              if (this.feedback.success == true) {
              } else {
              }
            } else {
            }
          },
          errorResponse => {
            console.log(errorResponse);
          }
        );
    },
    toggleLang() {
      this.showLang = !this.showLang;
    },
    checkDomain() {
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (
        this.globeArray.includes(site) ||
        this.smartArray.includes(site) ||
        this.jimMy.includes(site) ||
        this.app88.includes(site) ||
        this.app2.includes(site) ||
        this.app3.includes(site) ||
        this.app4.includes(site) ||
        this.app5.includes(site) ||
        this.app6.includes(site) ||
        this.app7.includes(site) ||
        this.globe1.includes(site) ||
        this.globe2.includes(site) ||
        this.globe3.includes(site) ||
        this.globe4.includes(site) ||
        // this.affiBlack.includes(site) ||
        this.adsss.includes(site) ||
        this.pin.includes(site) ||
        this.bio.includes(site) ||
        this.tips.includes(site) ||
        this.bb3.includes(site) ||
        this.blogg.includes(site) ||
        this.slots.includes(site) ||
        this.facebooks.includes(site) ||
        this.hdmovie.includes(site) ||
        this.john1.includes(site) || 
        this.annah.includes(site) ||
        this.marjz.includes(site) ||
        this.shuriken.includes(site) ||
        this.tengsss.includes(site) ||
        this.moneymeme.includes(site) ||
        this.globee.includes(site) ||
        this.ee6688.includes(site) ||
        this.regina.includes(site) ||
        this.youtube.includes(site) ||
        this.instagram33.includes(site)
      ) {
        $("#regModal").modal("show");
      }
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true;
        this.showTutorial = true;
        // this.showTopbanner = true;
        this.showDownload = false
      } else {
        this.isIOS = false;
        this.showTutorial = false;
        // this.showTopbanner = false;
        this.showDownload = true
      }
    },
    hideTopbanner(){
      this.showTopbanner = false
    },
    hideDownload(){
      this.showDownload = false
    },
    hideTutorial() {
      this.showTutorial = false;
    },
    openTutorial() {
      $("#modal-tutorial").modal("show");
    },
    gamification() {
      // console.log('here', window._smartico)
      // window._smartico.dp('dp:gf');
      _smartico.dp("dp:gf");
    },
    rules() {
      // _smartico.dp("dp:gf_section&id=91")  //rules
      _smartico.dp("dp:gf_saw"); //wheel
    },
    eventAction() {
      if (this.isLoggedIn) {
        $("#leaderboard-modal").modal("show");
        // window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 2} )
      } else {
        this.openLogModal();
      }
    },
    toggleIcon() {
      this.hideIcon = !this.hideIcon;
    },
    openModal(target) {
      $(target).modal("show");
    },
    getDisplayWord() {
      switch (this.$router.currentRoute.path) {
        case "/referral":
          return this.$t("ui.referral");
        case "/profile":
          return this.$t("ui.profile");
        case "/deposit":
          return this.$t("ui.deposit");
        case "/withdrawal":
          return this.$t("ui.withdrawal");
        case "/statement":
          return this.$t("ui.statement");
        case "/inbox":
          return this.$t("ui.inbox");
        case "/contactUs":
          return this.$t("ui.follow_us");
        case "/promotions":
          return this.$t("ui.promotion");
        case "/livestream":
          return "Live Stream"
        case "/ambassador":
          return "Ambassador"
        case "/setting":
          return this.$t('ui.setting');
	case "/vip":
          return "VIP";
      }
    },
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload);
      this.showLang = false;
    },
    checkSize() {
      if ($(window).width() < 681) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    // triggerDownload() {
    //   this.triggerEvent.prompt();
    //   //user response
    //   this.triggerEvent.userChoice.then(response => {
    //     if (response.outcome === "accepted") {
    //       this.showPrompt = false;
    //     } else {
    //     }
    //   });
    // },
    getSocialList() {
      this.$store
        .dispatch("user/getSocialList", {})
        .then(response => {
          if (response.success == true) {
            // this.socialList = response.data.value
          } else {
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
          }
        });
    },
    logout() {
      window._smartico_user_id = null;
      window._smartico_language = null;
      this.$store.dispatch("user/logout").catch(err => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.before-log {
  grid-template-columns: 50% 50%;
}
.article-view {
  @media (min-width: 681px) {
    padding-bottom: 0 !important;
  }
}
</style>
